import EventRepository from '@/repositories/EventRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'
import { IEventProps } from '@/entities/Event'
import { ErrorType, NotFoundError } from '@/common/errors'

export interface IFetchEventUseCaseParams {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway
}

export default class FetchEventUseCase implements BaseUseCase {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway

  constructor({ eventRepository, snapsnapGateway }: IFetchEventUseCaseParams) {
    this.eventRepository = eventRepository
    this.snapsnapGateway = snapsnapGateway
  }

  async execute(eventId: number): Promise<IEventProps> {
    try {
      const event = await this.snapsnapGateway.Event.getEvent(eventId)
      this.eventRepository.saveEvents([event])
      return event
    } catch (error) {
      if (error.status === ErrorType.NOT_FOUND) {
        throw new NotFoundError('event not found!')
      }
      throw error
    }
  }
}
